import styled from "styled-components"
import Heading from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import ListContent from "./components/ListContentHome/ListContent"
import IconShine from "components/EvtKit/icons/IconShine"
import ListTypeDisc from "./components/ListComponent/ListTypeDisc"

const ContainerHome = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  padding: 48px 24px;
  background: #ffffff;
`

const Introduction = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-direction: column;
  padding: 16px 24px;
  box-shadow: 0px 1px 4px 0px #00000026;
  border-radius: 8px;
`

const IntroductionContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-direction: column;
`

const DividerLine = styled.p`
  height: 2px;
  width: 96%;
  background-color: ${(props) => props.theme.palette.gray_light};
  opacity: 0.6;
`

const ContentWithImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`

const Content = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  width: 100%;
`

const Home = () => (
  <Heading variant="h2">
    <ContainerHome>
      <Introduction>
        <Heading variant="h5" color="primary-alt-soft">
          Introdução ao Portal
        </Heading>
        <IntroductionContent>
          <Content>
            <BodyText size="medium" weight="regular" color="gray-dark">
              O <b>SHELF Marketplace</b> é uma plataforma inovadora que permite aos usuários criar,{" "}
              <b>gerenciar e vender</b> seus próprios produtos digitais e soluções SaaS com{" "}
              <b>facilidade e flexibilidade</b>. Ideal para empreendedores digitais, empresas de tecnologia e criadores
              de conteúdo, o portal oferece ferramentas poderosas para criar produtos personalizados, incluindo
              variações de <b>planos, eventos e possibilidades de afiliação</b>.
            </BodyText>
            <BodyText size="medium" weight="regular" color="gray-dark">
              Com o Portal Marketplace, você pode:
            </BodyText>
            <ListTypeDisc
              description={
                <>
                  <b>Criar Produtos, Planos personalizados e seus variáveis eventos</b>: Desenvolva produtos digitais
                  completos com diferentes níveis de planos para atender às diversas necessidades de seus clientes.
                </>
              }
              className="disc"
              classNameLI="list-item"
            />
            <ListTypeDisc
              description={
                <>
                  <b>Gerenciar Eventos</b>: Organize e gerencie eventos de diversas vertentes, diretamente na
                  plataforma.
                </>
              }
              className="disc"
              classNameLI="list-item"
            />
            <ListTypeDisc
              description={
                <>
                  <b>Configurar Afiliação</b>: Amplie o alcance do seu negócio criando seu sistema de afiliação,
                  permitindo que outros promovam seus produtos em troca de comissões.
                </>
              }
              className="disc"
              classNameLI="list-item"
            />
            <BodyText size="medium" weight="regular" color="gray-dark">
              Tudo isso em um ambiente intuitivo e fácil de usar, projetado para otimizar a experiência do usuário e
              maximizar o sucesso de seus produtos digitais e seu negócio.
            </BodyText>
          </Content>
          <DividerLine />
          <ContentWithImg>
            <IconShine />
            <BodyText size="medium" weight="regular" color="gray-dark">
              Para tornar sua experiência de uso mais dinâmica no Portal, preparamos algumas orientações abaixo para que
              você usufrua facilmente das funcionalidades. Como esta é uma <b>simulação explicativa</b>, fique à vontade
              para explorar as funcionalidades do Portal quando quiser.
            </BodyText>
          </ContentWithImg>
        </IntroductionContent>
      </Introduction>
      <ListContent />
    </ContainerHome>
  </Heading>
)

export default Home
